"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringHelper = (function () {
    function StringHelper() {
    }
    StringHelper.pluralize = function (input, count) {
        if (!StringHelper.isPlural(count)) {
            return input;
        }
        input = input.replace("Monat", "Monate");
        input = input.replace("Woche", "Wochen");
        input = input.replace("Tag", "Tage");
        return input;
    };
    StringHelper.isPlural = function (count) {
        var pluralMinCount = 2;
        return count >= pluralMinCount;
    };
    StringHelper.shortenPeriodDescription = function (periodDescription) {
        var result = periodDescription.replace(/ *\([^)]*\) */g, "");
        result = result.replace("Montag-Freitag", "Mo-Fr");
        result = result.replace("Samstag-Sonntag", "Sa-So");
        return result.trim();
    };
    StringHelper.removeAverageSymbol = function (input) {
        return input.replace("Ø", "").trim();
    };
    return StringHelper;
}());
exports.StringHelper = StringHelper;
//# sourceMappingURL=stringHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/stringHelper.js
// module id = 69
// module chunks = 0